const STATS = [
  { value: "200+", label: "Projects delivered" },
  { value: "40+", label: "Years combined experience" },
  { value: "24/7", label: "On-call support" },
  { value: "30%", label: "Avg. cloud cost saved" },
];

export default function Stats() {
  return (
    <section className="stats-band">
      <div className="container">
        <div className="stats-band__grid">
          {STATS.map((s) => (
            <div key={s.label} className="stats-band__item">
              <div className="stats-band__value">{s.value}</div>
              <div className="stats-band__label">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
